/**
 * WalterGO Homepage Umami-Tracker
 * Spec: analytics/tracking-spec.md §3.2
 *
 * EVENTS:
 *   home.hero.primary_cta      —
 *   home.hero.secondary_cta    —
 *   home.hero.video_open       —    (Click auf den Sekundär-Button bei aktivem Video-Modal)
 *   home.proof_bar.partner_click   cta_label
 *   home.lifestyle.view        —
 *   home.pricing.compare_click position  (0=Sanitätshaus, 1=WalterGO, 2=Podologe)
 *   home.steps.view            —
 *   home.faq.toggle            position
 *   home.reviews.view          —
 *   home.cta.click             position: 'primary' | 'secondary'
 *
 * Sections markieren sich mit data-home-section="<name>".
 * FAQ + Steps sind shared mit PDP — siehe Conditional in faq.liquid / steps-process.liquid.
 */
(function () {
  'use strict';

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  function initSectionViews() {
    if (typeof window.wgTrackVisibility !== 'function') {
      return setTimeout(initSectionViews, 200);
    }
    document.querySelectorAll('[data-home-section]').forEach(function (el) {
      var name = el.dataset.homeSection;
      if (!name) return;
      window.wgTrackVisibility(
        '[data-home-section="' + name + '"]',
        'home.' + name + '.view'
      );
    });
  }

  function initSectionClicks() {
    // FAQ-Toggle innerhalb [data-home-section="faq"]
    document.querySelectorAll('[data-home-section="faq"] details').forEach(function (det, i) {
      det.addEventListener('toggle', function () {
        if (det.open) track('home.faq.toggle', { position: i });
      });
    });
  }

  function init() {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;
    initSectionViews();
    initSectionClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
